export class ConfirmationList {
  type: number;
  ids: any;
  isArchive: boolean;
  moduleId: number;
  headerText: string;
  detailText?: string;
  successMessage?: string;
}
